/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, current: NonNullable<unknown>, required: NonNullable<unknown> }} Version_Gate_Feedback_SingleInputs */



/**
* | output |
* | --- |
* | "{label}: {current} (Req > {required})" |
*
* @param {Version_Gate_Feedback_SingleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const version_gate_feedback_single = /** @type {((inputs: Version_Gate_Feedback_SingleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Version_Gate_Feedback_SingleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.label}: ${i?.current} (Req > ${i?.required})`)
	return /** @type {LocalizedString} */ (`${i?.label} : ${i?.current} (Req > ${i?.required})`)
});